import { render } from "./SpAppAlert.vue?vue&type=template&id=c625be72&scoped=true"
import script from "./SpAppAlert.vue?vue&type=script&lang=js"
export * from "./SpAppAlert.vue?vue&type=script&lang=js"

import "./SpAppAlert.vue?vue&type=style&index=0&id=c625be72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c625be72"]])

export default __exports__